import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  tipoCarga: { value: null, matchMode: FilterMatchMode.CONTAINS },
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  nombreExportador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  embarcador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  booking: { value: null, matchMode: FilterMatchMode.CONTAINS },
  observaciones: { value: null, matchMode: FilterMatchMode.CONTAINS },
  mercaderia: { value: null, matchMode: FilterMatchMode.CONTAINS },
  destinoFinal: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tamano: { value: null, matchMode: FilterMatchMode.CONTAINS },
  temperatura: { value: null, matchMode: FilterMatchMode.CONTAINS },
  ventilacion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  imos: { value: null, matchMode: FilterMatchMode.CONTAINS },
  uns: { value: null, matchMode: FilterMatchMode.CONTAINS },
  fecha: { value: null, matchMode: FilterMatchMode.DATE_IS },
  precinto1: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto2: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto3: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto4: { value: null, matchMode: FilterMatchMode.CONTAINS },
  mgw: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tara: { value: null, matchMode: FilterMatchMode.CONTAINS },
  peso: { value: null, matchMode: FilterMatchMode.CONTAINS },
  fechaPTI: { value: null, matchMode: FilterMatchMode.CONTAINS },
  humedad: { value: null, matchMode: FilterMatchMode.CONTAINS },
  o2: { value: null, matchMode: FilterMatchMode.CONTAINS },
  cO2: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
